module.exports = __webpack_public_path__ + "static/media/atm-locator-x.637d22b8.png";